
    import React, { Fragment } from 'react';
    
    
    const Markdown = () => (<Fragment><h1 id="v232">v2.3.2</h1>
<p><em><strong>Released</strong>: July 3rd, 2025</em></p>
<h3 id="bug-fix">Bug Fix</h3>
<ul>
<li>Fixed an issue where searching Categories on the User Filters wouldn&#39;t list Subcategories or allow them to be selected </li>
</ul>
<hr/>
<h1 id="v230">v2.3.0</h1>
<p><em><strong>Released</strong>: April 19th, 2025</em></p>
<h3 id="feature">Feature</h3>
<ul>
<li>Added support for users who could not connect to our realtime Live-Update services &#40;Websockets&#41;</li>
</ul>
<hr/>
<h1 id="v224">v2.2.4</h1>
<p><em><strong>Released</strong>: February 8th, 2025</em></p>
<h3 id="bug-fix-1">Bug Fix</h3>
<ul>
<li>Fixed an issue where Events within a short date/time range wouldn&#39;t be listed</li>
<li>Fixed a performance issue regarding Categories fetching</li>
</ul>
<hr/>
<h1 id="v223">v2.2.3</h1>
<p><em><strong>Released</strong>: November 15th, 2024</em></p>
<h3 id="bug-fix-2">Bug Fix</h3>
<ul>
<li>Fixed an issue where multiple Channel Listings embeds on a page would overwrite one another&#39;s filter state</li>
</ul>
<hr/>
<h1 id="v222">v2.2.2</h1>
<p><em><strong>Released</strong>: June 14th, 2024</em></p>
<h3 id="feature-1">Feature</h3>
<ul>
<li>Added new preference: Pagination positioning.<ul>
<li>You can now select to show the Pagination on Top/Above of the listing, Below it, or both.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2150">v2.1.50</h1>
<p><em><strong>Released</strong>: November 27th, 2023</em></p>
<h3 id="bug-fix-3">Bug Fix</h3>
<ul>
<li>Updated how audio download links were generated for recently published Events &#40;affects only the Table layout&#41;</li>
</ul>
<hr/>
<h1 id="v2149">v2.1.49</h1>
<p><em><strong>Released</strong>: March 17th, 2023</em></p>
<h3 id="bug-fix-4">Bug Fix</h3>
<ul>
<li>Adjusting grid column breakpoint methods to better fit screen sizes and confined layouts</li>
</ul>
<hr/>
<h1 id="v2148">v2.1.48</h1>
<p><em><strong>Released</strong>: March 10th, 2023</em></p>
<h3 id="refactor">Refactor</h3>
<ul>
<li>Updated the Calendar Dropdowns to use the OS/System Calendar widgets.</li>
</ul>
<hr/>
<h1 id="v2147">v2.1.47</h1>
<p><em><strong>Released</strong>: March 3rd, 2023</em></p>
<h3 id="refactor-1">Refactor</h3>
<ul>
<li>Refactored the visual style and layout for the Grid View</li>
</ul>
<hr/>
<h1 id="v2146">v2.1.46</h1>
<p><em><strong>Released</strong>: February 24th, 2023</em></p>
<h3 id="bug-fixes">Bug Fixes</h3>
<ul>
<li>Fixed an issue causing Events in a &quot;Publishing&quot; state to not appear for certain Status Group preferences</li>
</ul>
<hr/>
<h1 id="v2145">v2.1.45</h1>
<p><em><strong>Released</strong>: February 17th, 2023</em></p>
<h3 id="bug-fixes-1">Bug Fixes</h3>
<ul>
<li>Add to Calendar &#40;&quot;Remind Me&quot;&#41; button now inherits the sites font color.</li>
</ul>
<hr/>
<h1 id="v2144">v2.1.44</h1>
<p><em><strong>Released</strong>: February 2nd, 2023</em></p>
<h3 id="bug-fixes-2">Bug Fixes</h3>
<p><strong>User Search &amp; Filtering:</strong></p>
<ul>
<li>Addressed an issue which caused the display of the down arrow in the Year selector to not display properly.</li>
</ul>
<hr/>
<h1 id="v2141">v2.1.41</h1>
<p><em><strong>Released</strong>: May 11, 2022</em></p>
<h2 id="bug-fixes-3">Bug Fixes</h2>
<ul>
<li>Fixed an issue where Events would not display properly in certain mobile viewports</li>
</ul>
<hr/>
<h1 id="v2133">v2.1.33</h1>
<p><em><strong>Released</strong>: Jan. 24, 2022</em></p>
<h2 id="features">Features</h2>
<ul>
<li>Added an &quot;Add to Calendar&quot; button</li>
</ul>
</Fragment>);
    export default Markdown;
  